module.exports = __webpack_public_path__ + "static/media/Doubt session.f84a8c8a.jpeg";